import { format, formatDistanceToNow, isSameDay, isToday, isYesterday } from 'date-fns';
import { i18n, getCurrentFnsLocale } from '../services';
import { hasValue } from './typeguards.utils';
export const wait = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
};
// extract Unix timestamp from a UUID v7 value without an external library
export const extractTimestampFromUUIDv7 = (uuid) => {
    // split the UUID into its components
    const parts = uuid.split('-');
    // the second part of the UUID contains the high bits of the timestamp (48 bits in total)
    const highBitsHex = parts[0] + parts[1].slice(0, 4);
    // convert the high bits from hex to decimal
    // the UUID v7 timestamp is the number of milliseconds since Unix epoch (January 1, 1970)
    const timestampInMilliseconds = parseInt(highBitsHex, 16);
    // convert the timestamp to a Date object
    return new Date(timestampInMilliseconds);
};
export const formatTimeString = (date, isUuidv7) => {
    if (!hasValue(date)) {
        return '';
    }
    if (isUuidv7 && typeof date === 'string') {
        return format(extractTimestampFromUUIDv7(date), 'HH:mm');
    }
    else {
        return format(new Date(date), 'HH:mm');
    }
};
export const getDateWithoutTime = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};
export const getIsTodayString = (date) => {
    const targetDate = new Date(date);
    if (isToday(targetDate)) {
        return i18n.t('labels.today');
    }
    if (isYesterday(targetDate)) {
        return i18n.t('labels.yesterday');
    }
    const isCurrentYear = targetDate.getFullYear() === new Date().getFullYear();
    return format(targetDate, isCurrentYear ? 'd MMMM' : 'd MMMM yyyy', {
        locale: getCurrentFnsLocale()
    });
};
export const getIsTodayShortString = (date) => {
    const targetDate = new Date(date);
    if (isToday(targetDate)) {
        return i18n.t('labels.today');
    }
    if (isYesterday(targetDate)) {
        return i18n.t('labels.yesterday');
    }
    const isCurrentYear = targetDate.getFullYear() === new Date().getFullYear();
    return format(targetDate, isCurrentYear ? 'd MMM' : 'd MMM, yyyy', {
        locale: getCurrentFnsLocale()
    });
};
export const getIsTodayWithTimeStrings = (date) => {
    const targetDate = new Date(date);
    if (isToday(targetDate)) {
        return `${i18n.t('labels.today')}, ${format(targetDate, 'HH:mm', { locale: getCurrentFnsLocale() })}`;
    }
    if (isYesterday(targetDate)) {
        return `${i18n.t('labels.yesterday')}, ${format(targetDate, 'HH:mm', { locale: getCurrentFnsLocale() })}`;
    }
    return format(targetDate, `d MMMM, HH:mm`, {
        locale: getCurrentFnsLocale()
    });
};
export const getDateTimeString = (date, skipCurrentYear) => {
    const targetDate = new Date(date);
    if (skipCurrentYear && targetDate.getFullYear() === new Date().getFullYear()) {
        return format(targetDate, `d MMMM, HH:mm`, {
            locale: getCurrentFnsLocale()
        });
    }
    return format(targetDate, `d MMMM yyyy, HH:mm`, {
        locale: getCurrentFnsLocale()
    });
};
export const getDateTimeStringWithSecs = (date) => {
    const targetDate = new Date(date);
    if (isToday(targetDate)) {
        return `${i18n.t('labels.today')}, ${format(targetDate, `HH:mm:ss`, {
            locale: getCurrentFnsLocale()
        })}`;
    }
    if (isYesterday(targetDate)) {
        return `${i18n.t('labels.yesterday')}, ${format(targetDate, `HH:mm:ss`, {
            locale: getCurrentFnsLocale()
        })}`;
    }
    if (targetDate.getFullYear() === new Date().getFullYear()) {
        return format(targetDate, `d MMMM, HH:mm:ss`, {
            locale: getCurrentFnsLocale()
        });
    }
    return format(targetDate, `d MMMM yyyy, HH:mm:ss`, {
        locale: getCurrentFnsLocale()
    });
};
export const formatDurationMs = (milliseconds) => {
    const totalSeconds = Math.round(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    if (minutes === 0) {
        return `${seconds}s`;
    }
    return `${minutes}m ${seconds}s`;
};
export const isSameDayEx = (date1, date2) => {
    return isSameDay(new Date(date1), new Date(date2));
};
export const formatRelativeTime = (isoDate) => {
    return formatDistanceToNow(new Date(isoDate), { addSuffix: true, locale: getCurrentFnsLocale() });
};
//# sourceMappingURL=time.utils.js.map